import {
  CLEAR_VBT_DATA,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_EXERCISES_START,
  FETCH_PUBLIC_VBT_DATA_FULFILLED,
  FETCH_PUBLIC_VBT_DATA_REJECTED,
  FETCH_PUBLIC_VBT_DATA_START,
  FETCH_SHARE_VBT_DASH_LINK_FULFILLED,
  FETCH_SHARE_VBT_DASH_LINK_REJECTED,
  FETCH_SHARE_VBT_DASH_LINK_START,
  FETCH_VBT_DATA_FULFILLED,
  FETCH_VBT_DATA_REJECTED,
  FETCH_VBT_DATA_START,
  FETCH_VBT_TEMPLATES_FULFILLED,
  FETCH_VBT_TEMPLATES_REJECTED,
  FETCH_VBT_TEMPLATES_START,
  SET_ABOUT_VBT_DASH_MODAL,
  SET_DELETE_VBT_DASH_MODAL,
  SET_DUPLICATE_VBT_DASH_MODAL,
  SET_EDIT_VBT_DASH_MODAL,
  SET_IS_FILTER_SHOWING,
  SET_IS_VBT_DASH_DISPLAYED,
  SET_NEW_VBT_DASH,
  SET_VBT_ONBOARDING_MODAL,
  SET_SAVE_VBT_DASH_MODAL,
  SET_SELECTED_ATHLETE,
  SET_SELECTED_EXERCISE,
  SET_SHARE_VBT_DASH_MODAL,
  SET_UNSAVED_VBT_DASH_MODAL,
  SET_VBT_DASH_VIEW,
} from './actionTypes';

const initialState = {
  aboutModalShowing: false,
  deleteModalShowing: false,
  duplicateModalShowing: false,
  editModalShowing: false,
  isAthleteSelected: false,
  isDashDisplayed: false,
  isExerciseSelected: false,
  isFilterShowing: false,
  isLoadingExercises: false,
  isNewVBTDash: false,
  isReadOnlyView: false,
  isShareDashLinkLoading: false,
  isVBTDataLoading: false,
  onboardingModalShowing: false,
  saveModalShowing: false,
  shareModalShowing: false,
  templatesLoading: false,
  unsavedModalShowing: false,
  vbtDashView: 'overview',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_VBT_DATA:
      return {
        ...state,
        aboutModalShowing: false,
        deleteModalShowing: false,
        duplicateModalShowing: false,
        editModalShowing: false,
        isAthleteSelected: false,
        isDashDisplayed: false,
        isExerciseSelected: false,
        isFilterShowing: false,
        isNewVBTDash: false,
        saveModalShowing: false,
        shareModalShowing: false,
        vbtDashView: 'overview',
      };
    case FETCH_EXERCISES_START:
      return {
        ...state,
        isLoadingExercises: true,
      };
    case FETCH_EXERCISES_FULFILLED:
      return {
        ...state,
        isLoadingExercises: false,
      };
    case FETCH_EXERCISES_REJECTED:
      return {
        ...state,
        isLoadingExercises: false,
      };
    case FETCH_PUBLIC_VBT_DATA_START: {
      return {
        ...state,
        isVBTDataLoading: true,
        isReadOnlyView: true,
      };
    }
    case FETCH_PUBLIC_VBT_DATA_FULFILLED: {
      return {
        ...state,
        isExerciseSelected: !!action.payload.exercise?.id,
        isVBTDataLoading: false,
      };
    }
    case FETCH_PUBLIC_VBT_DATA_REJECTED: {
      return {
        ...state,
        isVBTDataLoading: false,
      };
    }
    case FETCH_VBT_DATA_START:
      return {
        ...state,
        isVBTDataLoading: true,
      };
    case FETCH_VBT_DATA_FULFILLED:
      return {
        ...state,
        isVBTDataLoading: false,
      };
    case FETCH_VBT_DATA_REJECTED:
      return {
        ...state,
        isVBTDataLoading: false,
      };
    case FETCH_SHARE_VBT_DASH_LINK_START:
      return {
        ...state,
        isShareDashLinkLoading: true,
      };
    case FETCH_SHARE_VBT_DASH_LINK_FULFILLED:
      return {
        ...state,
        isShareDashLinkLoading: false,
      };
    case FETCH_SHARE_VBT_DASH_LINK_REJECTED:
      return {
        ...state,
        isShareDashLinkLoading: false,
      };
    case FETCH_VBT_TEMPLATES_START:
      return {
        ...state,
        templatesLoading: true,
      };
    case FETCH_VBT_TEMPLATES_FULFILLED:
      return {
        ...state,
        templatesLoading: false,
      };
    case FETCH_VBT_TEMPLATES_REJECTED:
      return {
        ...state,
        templatesLoading: false,
      };
    case SET_ABOUT_VBT_DASH_MODAL:
      return {
        ...state,
        aboutModalShowing: action.payload.bool,
      };
    case SET_DELETE_VBT_DASH_MODAL:
      return {
        ...state,
        deleteModalShowing: action.payload.bool,
      };
    case SET_DUPLICATE_VBT_DASH_MODAL:
      return {
        ...state,
        duplicateModalShowing: action.payload.bool,
      };
    case SET_EDIT_VBT_DASH_MODAL:
      return {
        ...state,
        editModalShowing: action.payload.bool,
      };
    case SET_IS_FILTER_SHOWING:
      return {
        ...state,
        isFilterShowing: action.payload,
      };
    case SET_IS_VBT_DASH_DISPLAYED:
      return {
        ...state,
        isDashDisplayed: action.payload,
      };
    case SET_NEW_VBT_DASH:
      return {
        ...state,
        isNewVBTDash: action.payload,
      };
    case SET_VBT_ONBOARDING_MODAL:
      return {
        ...state,
        onboardingModalShowing: action.payload,
      };
    case SET_SAVE_VBT_DASH_MODAL:
      return {
        ...state,
        saveModalShowing: action.payload,
      };
    case SET_SELECTED_ATHLETE:
      return {
        ...state,
        isAthleteSelected: action.payload.bool,
      };
    case SET_SELECTED_EXERCISE:
      return {
        ...state,
        isExerciseSelected: action.payload.bool,
      };
    case SET_SHARE_VBT_DASH_MODAL:
      return {
        ...state,
        shareModalShowing: action.payload.bool,
      };
    case SET_UNSAVED_VBT_DASH_MODAL:
      return {
        ...state,
        unsavedModalShowing: action.payload,
      };
    case SET_VBT_DASH_VIEW:
      return {
        ...state,
        vbtDashView: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
